<div class="container-fluid py-lg-5" id="proj">
    <h2 class="title-project">Mes Projets</h2>
    <div class="col-sm-8 offset-sm-2">


        <!-- FIRST ROW -->
        <div class="row ">
            <div class="col-sm-4 proj-body">
                <mdb-card class="project-card">
                    <mdb-card-img src="assets/geo.png"></mdb-card-img>
                    <mdb-card-body>
                        <h4>CREATION D'UN JEU DE GEOGRAPHIE POUR ENFANT REALISE EN HTML CSS JS</h4>
                        <p>Janvier 2021 - ...</p>
                        <a mdbBtn gradient="sunny-morning" mdbWavesEffect (click)="onClick('jeu_geo')">
                            <mdb-icon fas icon="angle-right"></mdb-icon> Voir plus</a>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col-sm-4 proj-body">
                <mdb-card class="project-card">
                    <mdb-card-img src="assets/cvv.png"></mdb-card-img>
                    <mdb-card-body>
                        <h4>Création de mon CV en HTML CSS </h4>
                        <p>Mars - Juin 2021</p>
                        <a mdbBtn gradient="sunny-morning" mdbWavesEffect (click)="onClick('cv')">
                            <mdb-icon fas icon="angle-right"></mdb-icon> Voir plus</a>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col-sm-4 proj-body">
                <mdb-card class="project-card">
                    <mdb-card-img src="assets/bete.png"></mdb-card-img>
                    <mdb-card-body>
                        <h4>Simulateur de bestiole en java </h4>
                        <p>Mars - Juin 2021</p>
                        <a mdbBtn gradient="sunny-morning" mdbWavesEffect (click)="onClick('bestiole')">
                            <mdb-icon fas icon="angle-right"></mdb-icon> Voir plus</a>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>

        <!-- SECOND ROW -->
        <div class="row py-sm-5 ">
            <div class="col-sm-4 proj-body">
                <mdb-card class="project-card">
                    <mdb-card-img src="assets/ten.PNG"></mdb-card-img>
                    <mdb-card-body>
                        <h4>Site de tennis en HTML </h4>
                        <p>Mars 2021</p>
                        <a mdbBtn gradient="sunny-morning" mdbWavesEffect (click)="onClick('tennis')">
                            <mdb-icon fas icon="angle-right"></mdb-icon> Voir plus</a>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col-sm-4 proj-body">
                <mdb-card class="project-card">
                    <mdb-card-img src="assets/app.png"></mdb-card-img>
                    <mdb-card-body>
                        <h4>Application en Windev qui gère les provisions de l’entreprise plus particulièrement les différents compteurs de temps des salariés pour la comptabilité.</h4>
                        <p>Septembre - Juin 2021</p>
                        <a mdbBtn gradient="sunny-morning" mdbWavesEffect (click)="onClick('windev')">
                            <mdb-icon fas icon="angle-right"></mdb-icon> Voir plus</a>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col-sm-4 proj-body">
                <mdb-card class="project-card">
                    <mdb-card-img src="assets/co.png"></mdb-card-img>
                    <mdb-card-body>
                        <h4>Site E-Commerce réalisé en HTML CSS PHP MYSQL pendant mon BTS SIO </h4>
                        <p>Octobre - Janvier 2021</p>
                        <a mdbBtn gradient="sunny-morning" mdbWavesEffect (click)="onClick('btsprojet')">
                            <mdb-icon fas icon="angle-right"></mdb-icon> Voir plus</a>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>

        <!-- THIRD ROW -->
        <div class="row py-sm-5 ">
            <div class="col-sm-4 proj-body">
                <mdb-card class="project-card">
                    <mdb-card-img src="assets/POR_proj_smm.PNG" alt="Portoflio"></mdb-card-img>
                    <mdb-card-body>
                        <h4>Création d'un portfolio en Angular</h4>
                        <p>Novembre - Décembre 2020</p>
                        <a mdbBtn gradient="sunny-morning" mdbWavesEffect (click)="onClick('portfolio')">
                            <mdb-icon fas icon="angle-right"></mdb-icon> Voir plus</a>
                    </mdb-card-body>
                </mdb-card>
            </div>
        
         
        </div>

    
    </div>
</div>